/*
 * A link to a question in the report (?question=<questionId>), e.g. from the
 * proctoring review room. The report lists questions only inside a drill-down
 * bucket (BucketDetails), so the link opens the first bucket, in display order,
 * one of whose traits lists the question.
 */

/**
 * The trait ids of the buckets, each once, in bucket order.
 * @param {Array<{traitsMeta?: Object<string, Object>}>} buckets
 * @returns {string[]}
 */
export function traitIdsOf(buckets) {
  const ids = new Set();
  (buckets || []).forEach((bucket) => {
    Object.keys(bucket?.traitsMeta || {}).forEach((id) => ids.add(id));
  });
  return Array.from(ids);
}

/**
 * The first bucket (in the given order) one of whose traits lists the question.
 * @param {Array<{id: string, traitsMeta?: Object<string, Object>}>} buckets  the drill-down buckets, in display order
 * @param {Object<string, {questions?: Array<{question?: {id: string}}>}>} quizData  quiz-details data, by trait id
 * @param {string} questionId
 * @returns {Object|null} the bucket, or null when no listed bucket has the question
 */
export function bucketOfQuestion(buckets, quizData, questionId) {
  if (!questionId || !quizData) return null;
  const listsQuestion = (traitId) =>
    (quizData[traitId]?.questions || []).some((elem) => elem?.question?.id === questionId);
  return (buckets || []).find((bucket) => Object.keys(bucket?.traitsMeta || {}).some(listsQuestion)) || null;
}
